interface FormHeaderProps {
    headerText: string,
    subHeaderText?: string
}

export default function FormHeader(props: FormHeaderProps) {
    return (
        <div className="pt-3 mb-12">
            <h1 className="text-3xl md:text-5xl font-semibold text-center text-[#93885B] ml-1">
                {props.headerText}
            </h1>
            {
                props.subHeaderText && <p className="mt-4 p-4 text-black">
                    {props.subHeaderText}
                </p>}
        </div>
    );
}